



























import { Prop, Component, Vue } from 'vue-property-decorator'
import { EventLogAPI } from '@/api/backend-client'
import { EventLog } from '@/api/model/event-log'
import { Contact } from '@/api/model/contact'
import { Referral } from '@/api/model/referral'

@Component
export default class ContactActivity extends Vue {
    @Prop() readonly contact!: Contact
    @Prop() readonly referral!: Referral
    eventLogs: EventLog[] = []
    loading: boolean = false

    async mounted() {
        if (this.contact || this.referral) {
            this.eventLogs = Array.from(new Set([
                ...this.contact.eventLogs,
                // ...this.referral.eventLogs,
            ]))
        } else {
            this.loading = true
            const result = await EventLogAPI.getPaged({})
            this.eventLogs = result.collection
            this.loading = false
        }
    }

    // Fairly hacky way, but a small step towards individual rendering of event types
    formatActivityEvent(log: EventLog) {
        switch (log.event) {
            case 'EmailSentEvent':
                return this.$t(`activity.${log.event}`, { user: log.name }) +
                    `: ${log.eventData.subject}`
            case 'ReferralStatusChangedEvent': {
                if (log.eventData.statusReason) {
                    return this.$t(`activity.${log.event}`, {
                        user: log.name,
                        pipelineName: log.pipelineName || 'onbekend',
                        status: this.$t(`referral.status.${log.eventData.status}`),
                    }) + ' (' + this.$t(`referral.statusReason.${log.eventData.statusReason}`) + ')'
                }

                return this.$t(`activity.${log.event}`, {
                    user: log.name,
                    pipelineName: log.pipelineName || 'onbekend',
                    status: this.$t(`referral.status.${log.eventData.status}`),
                })
            }
            default:
                return this.$t(`activity.${log.event}`, {
                    user: log.name,
                    pipelineName: log.pipelineName || 'onbekend',
                })
        }
    }

    get sortedEventLogs(): EventLog[] {
        return this.eventLogs
            .sort((a: EventLog, b: EventLog) => a.loggedAt > b.loggedAt ? -1 : 1)
    }

    get widgetAvatarSvg(): string[] {
        return [
            'brunette-circle',
            'blond-circle',
            'sylvana-circle',
        ]
    }

    // maybe later
    // async routeToDetail(log: EventLog) {
    //     if(log.referral) {
    //         await this.$router.push({
    //             name: 'tasks_detail',
    //             params: {
    //                 referralId: log.referral.id,
    //             }
    //         })
    //     }
    // }
}
